import { createAction, props } from '@ngrx/store';

export interface singleEdit{
    id: string,
    fundingControl: string | null,
    scoreControl: string | null,
    formStatus: boolean,
    comment: string | null
}

export interface OECIF_Form{
    id: string,
    formStatus: boolean | null,
    oge450: boolean | null,
    applicable: boolean | null
    recuse: boolean | null,
    appropriate6_3: boolean | null,
    onTopic: boolean | null,
    recommend_funding: boolean | null,
    explainFunding: string | null,
    comment: string | null
}
export interface OEPF_Form{
    id: string,
    oge450: boolean | null,
    recuse: boolean | null,
    appropriate6_4: boolean | null,
    transition_capable: boolean | null
    recommend_funding: boolean | null,
    explainFunding: string | null,
    formStatus: boolean | null,
    comment: string | null
}


export interface rankInfo{
    currentIndex: number,
    previousIndex: number
}

export const edit = createAction('[Seo List] Edit', props<{listItem:singleEdit}>());
export const create = createAction('[Seo List] Create', props<{content:any}>());

export const editQuadOECIF = createAction('[QUAD List] OECIF Edit', props<{listItem:OECIF_Form}>());
export const editQuadOEPF = createAction('[QUAD List] OEPF Edit', props<{listItem:OEPF_Form}>());




export const rankChangeQuad = createAction('[QUAD List] Rank Order Changed Requested', props<{rankInfo:rankInfo}>());

export const rankChangeSuccess = createAction('[Seo List] Rank Order Changed Success');
export const rankChangeFail = createAction('[Seo List] Rank Order Changed Failure');
export const clearSeoList = createAction('[Seo List] Clear request');


export const clearQuadList = createAction('[QUAD List] Clear request');



export const reset = createAction('[Seo List] Reset');
export const apiCallSeo = createAction('[Seo List] Api call');
export const loadSeoList = createAction('[Seo List] Started api call to load')
export const loadSeoListSucess = createAction('[Seo List] Api load sucess', props<{seoList:[]}>())
export const loadSeoListFailure = createAction('[Seo List] Api load Failure', props<{error:string}>())

export const loadQuadList = createAction('[QUAD List] Started api call to load', props<{user:string}>())

export const loadQuadListSucess = createAction('[QUAD List] Api load sucess', props<{quadList:[]}>())

export const loadQuadListFailure = createAction('[QUAD List] Api load Failure', props<{error:string}>())

export const selectProposalQuad = createAction('[Quad List] Seo Proposal Selected', props<{propUUID:any}>());


export const updateQuadListFromRecuse = createAction('[UPDATE QUAD List] update quad list from recuse', props<{quadList:[]}>())
export const unSelectQuad = createAction('[UNSELECT QUAD] unselected quad')